module.exports = __webpack_public_path__ + "static/media/point_detaile_light.56cbd02a.png";